module.exports = __webpack_public_path__ + "static/media/ReportsIcon.8b68ecca.svg";